module.exports = __webpack_public_path__ + "images/lipstick/empty_spaces/capturing_users-2b5f11c88e4709d866caa7b05beb6cd8.svg";